import styled from 'styled-components';

export const PageWrapStyles = styled.div`
  position: relative;
  width: 100%;
  max-width: 630px;
  margin: 0 auto;
  min-height: 720px;

  @media (max-width: 600px) {
    min-height: 540px;
  }

  iframe {
    border: none;
  }

  .source {
    font-size: 0.8em;
  }

  .headline {
    font-family: 'Ubuntu', sans-serif;
    font-size: 24px;
    line-height: 30px;
    font-weight: 700;
    color: #000;
    border-left: 4px solid #e12827;
    padding-left: 16px;
    margin-bottom: 20px;
  }
`;
